import { gql, useMutation } from '@apollo/client';
import { MutationHookOptions } from '@apollo/client/react/types/types';
import {
  EmailArticleMutation,
  EmailArticleMutationVariables,
} from '../../__generated__/queries-topic';

const EMAIL_ARTICLE_MUTATION = gql`
  mutation EmailArticle(
    $rawArticle: UUID!
    $recipients: [String!]!
    $comment: String
  ) {
    emailRawArticle(
      rawArticle: { id: $rawArticle }
      recipients: $recipients
      comment: $comment
    ) {
      success
    }
  }
`;

export const useEmailArticleSender = (
  options?: MutationHookOptions<
    EmailArticleMutation,
    EmailArticleMutationVariables
  >,
) =>
  useMutation<EmailArticleMutation, EmailArticleMutationVariables>(
    EMAIL_ARTICLE_MUTATION,
    options,
  );
